import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=3f3f04e0"
import script from "./NewsModal.vue?vue&type=script&lang=js"
export * from "./NewsModal.vue?vue&type=script&lang=js"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=3f3f04e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports